
<script>
	import preoutorderIndex from './preoutorder/index.vue'
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'wlnpurchaseworkorderIndex',
		props: {

		},
		render(h) {
			this.$slots.plug = [
				<preoutorder-index ref="preoutorderIndex" />,
			]			
			return listBase.render.call(this, h)
		},
		data() {
			return {
				moduleName: 'wlnpurchaseworkorder',
				windowName: '模块名称',
				windowType: 'modal',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			demo(){
				this.$refs.preoutorderIndex.modal_show()
			}
		},
		components: {
			preoutorderIndex
		}	
	}
</script>
